import { normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/graphic/noImg.svg'


const _withScopeId = n => (_pushScopeId("data-v-7ae1bb19"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lazyImg" }
const _hoisted_2 = ["data-url"]
const _hoisted_3 = { class: "lazyImg__slot" }
const _hoisted_4 = { class: "lazyImg__slot" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "lazyImg__item contain"
}, null, -1))
const _hoisted_6 = { class: "lazyImg__slot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _directive_lazy_image = _resolveDirective("lazy-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isError)
      ? _withDirectives((_openBlock(), _createElementBlock("img", {
          key: 0,
          class: _normalizeClass(["lazyImg__item", { hide: !_ctx.isLoaded && !_ctx.isError, contain: _ctx.imageFitContain }]),
          "data-url": _ctx.url,
          onLoad: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isLoaded = true)),
          onError: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isError = true))
        }, null, 42, _hoisted_2)), [
          [_directive_lazy_image]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.isLoaded && !_ctx.isError)
        ? _renderSlot(_ctx.$slots, "loading", { key: 0 }, () => [
            _createVNode(_component_el_skeleton, {
              class: "skeleton",
              animated: "",
              style: {"--el-skeleton-color":"#AFBEC7"}
            }, {
              template: _withCtx(() => [
                _createVNode(_component_el_skeleton_item, {
                  variant: "rect",
                  class: "skeleton"
                })
              ]),
              _: 1
            })
          ], true)
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.isError)
        ? _renderSlot(_ctx.$slots, "error", { key: 0 }, () => [
            _hoisted_5
          ], true)
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.isLoaded)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 }, undefined, true)
        : _createCommentVNode("", true)
    ])
  ]))
}